import { TitleColor } from '..';
import Text from '../Text';

const Education2018 = () => (
  <>
    <TitleColor text="Kurser 2018" smallTitle />
    <Text>
      <b>Christina Ingerslev</b>
      <br />
      Weekendkursus den 9. september: "Problemadfærd på træningsbanen."
    </Text>
    <Text>
      <b>Chirag Patel</b>
      <br />
      Weekendkursus den 26.-27. maj: "Hvalpetræning og socialisering. Frivillig håndtering."
    </Text>
    <Text>
      <b>Lise Bang Hansen</b>
      <br />
      Aftenseminar den 22. marts: "Vaccination af hunde."
    </Text>
  </>
);

export default Education2018;
